(function () {
  "use strict";

  const SELECTORS = {
    carousel: "[data-nav-banners-carousel]",
    track: "[data-nav-banners-track]",
    prevButton: "[data-nav-banners-prev]",
    nextButton: "[data-nav-banners-next]",
  };

  const updateButtons = (embla, prevButton, nextButton) => {
    if (!prevButton || !nextButton) return;
    prevButton.disabled = !embla.canScrollPrev();
    nextButton.disabled = !embla.canScrollNext();
  };

  const updateCentering = (embla, track) => {
    if (!track) return;
    const canScroll = embla.canScrollPrev() || embla.canScrollNext();
    track.classList.toggle("justify-center", !canScroll);
  };

  const initCarousel = (container) => {
    const viewport = container.querySelector(SELECTORS.carousel);
    const track = container.querySelector(SELECTORS.track);
    const prevButton = container.querySelector(SELECTORS.prevButton);
    const nextButton = container.querySelector(SELECTORS.nextButton);
    if (!viewport) return;

    const embla = window.EmblaCarousel(viewport, {
      loop: false,
      align: "start",
      skipSnaps: false,
      dragFree: true,
      containScroll: "trimSnaps",
    });

    const onUpdate = () => {
      updateButtons(embla, prevButton, nextButton);
      updateCentering(embla, track);
    };
    embla.on("select", onUpdate);
    embla.on("reInit", onUpdate);
    onUpdate();

    if (prevButton)
      prevButton.addEventListener("click", () => embla.scrollPrev());
    if (nextButton)
      nextButton.addEventListener("click", () => embla.scrollNext());
  };

  const init = () => {
    document
      .querySelectorAll("[data-nav-banners-container]")
      .forEach(initCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
